import './app.scss'
import './icon.scss';
import './common.scss';
import 'amfe-flexible'